export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8971.f1e3b114.jpg";